import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

import { computed } from 'vue'
import StoreProductCard from './StoreProductCard.vue'
import { storefrontTemplate, storefrontColumnsMobile, ProductCardVariant } from '@/global/state/StorefrontState'

/* global defineProps, defineEmits, withDefaults */

export default /*#__PURE__*/_defineComponent({
  __name: 'StoreProductGrid',
  props: {
    products: {},
    variant: { default: undefined },
    thumb: { type: Boolean, default: true }
  },
  emits: ['select'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const gridVariant = computed<ProductCardVariant>(() => props.variant ?? storefrontTemplate.value)

/** Image-top cards only: rows (classic) and the printed menu (minimal) are naturally one column on mobile. */
const COLUMN_AWARE: ProductCardVariant[] = ['grid', 'showcase', 'dark']
const columnsClass = computed(() => {
  const columns = storefrontColumnsMobile.value
  if (columns === 'auto' || !COLUMN_AWARE.includes(gridVariant.value)) return ''
  return `sf-product-grid--cols-${columns}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sf-product-grid", [`sf-product-grid--${gridVariant.value}`, columnsClass.value]])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
      return (_openBlock(), _createBlock(StoreProductCard, {
        key: product.id,
        product: product,
        variant: gridVariant.value,
        thumb: _ctx.thumb,
        onSelect: _cache[0] || (_cache[0] = (p) => emit('select', p))
      }, null, 8, ["product", "variant", "thumb"]))
    }), 128))
  ], 2))
}
}

})